const removeDoubleSpaces = (name: string) => name.trim().replace(/\s+/g, ' ');

export default removeDoubleSpaces;